import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Donut"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "donut"
    }}>{`Donut`}</h1>
    <p>{`Single value SVG donut chart`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Donut } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Donut value={1 / 2} />
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`value`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value to display in the chart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`min`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(default `}<inlineCode parentName="td">{`0`}</inlineCode>{`) Minimum value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`max`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(default `}<inlineCode parentName="td">{`1`}</inlineCode>{`) Maximum value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`title`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text for SVG `}<inlineCode parentName="td">{`<title>`}</inlineCode>{` tag`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(default `}<inlineCode parentName="td">{`128`}</inlineCode>{`) chart diameter`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`strokeWidth`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(default `}<inlineCode parentName="td">{`2`}</inlineCode>{`) stroke width`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`A `}<inlineCode parentName="p">{`title`}</inlineCode>{` attribute should be provided to the component for accessibility purposes.
By default `}<inlineCode parentName="p">{`aria-valuenow`}</inlineCode>{`, `}<inlineCode parentName="p">{`aria-valuemin`}</inlineCode>{`, and `}<inlineCode parentName="p">{`aria-valuemax`}</inlineCode>{` are set using the component's props.
The element uses `}<inlineCode parentName="p">{`role='img'`}</inlineCode>{` by default.
Pass any overrides or additional attributes for the SVG element as props.`}</p>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Donut variants can be defined anywhere in the `}<inlineCode parentName="p">{`theme`}</inlineCode>{` object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme variants
{
  styles: {
    donut: {
      color: 'red',
    },
  },
}
// <Donut variant='styles.donut' />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      